{
  "avalancheSize.label": "Mida d'allau",
  "avalancheSize.small": "petita",
  "avalancheSize.medium": "mitjana",
  "avalancheSize.large": "gran",
  "avalancheSize.very_large": "molt gran",
  "avalancheSize.extreme": "extrema",
  "snowpackStability.label": "Estabilitat del mantell de neu",
  "snowpackStability.good": "bona",
  "snowpackStability.fair": "regular",
  "snowpackStability.poor": "pobre",
  "snowpackStability.very_poor": "molt pobre",
  "frequency.label": "freqüència",
  "frequency.none": "cap",
  "frequency.few": "poques",
  "frequency.some": "algunes",
  "frequency.many": "moltes",
  "dangerRating.label": "Grau de perill",
  "dangerRating.missing": "absent",
  "dangerRating.missing.long": "Absent",
  "dangerRating.no_snow": "sense neu",
  "dangerRating.no_snow.long": "Sense Neu",
  "dangerRating.no_rating": "Sense  grau de perill",
  "dangerRating.no_rating.long": "Sense Grau de Perill",
  "dangerRating.low": "feble",
  "dangerRating.low.long": "Grau de Perill 1 — Feble",
  "dangerRating.low.speech": "Perill d'allaus feble, doncs grau de perill 1",
  "dangerRating.moderate": "moderat",
  "dangerRating.moderate.long": "Grau de Perill 2 — Moderat",
  "dangerRating.moderate.speech": "Perill d'allaus moderat, doncs grau de perill dos",
  "dangerRating.considerable": "Marcat",
  "dangerRating.considerable.long": "Grau de Perill 3 — Marcat",
  "dangerRating.considerable.speech": "Perill d'allaus marcat, doncs grau de perill tres",
  "dangerRating.high": "Fort",
  "dangerRating.high.long": "Grau de Perill 4 — Fort",
  "dangerRating.high.speech": "Perill d'allaus fort, doncs grau de perill quatre",
  "dangerRating.very_high": "molt fort",
  "dangerRating.very_high.long": "Grau de Perill 5 — Molt Fort",
  "dangerRating.very_high.speech": "Perill d'allaus molt fort, doncs grau de perill cinc",
  "avalancheType.label": "Tipus d'allau",
  "avalancheType.slab": "Allau de placa",
  "avalancheType.loose": "Allau sense cohesió",
  "avalancheType.glide": "Allau de lliscament de neu",
  "avalancheProblem.label": "Problema d'allaus",
  "avalancheProblem.new_snow": "Neu recent",
  "avalancheProblem.wind_slab": "Placa de vent",
  "avalancheProblem.persistent_weak_layers": "Capa feble persistent",
  "avalancheProblem.wet_snow": "Neu humida",
  "avalancheProblem.gliding_snow": "Lliscament de neu",
  "avalancheProblem.favourable_situation": "Situació favorable",
  "avalancheProblem.cornices": "Cornises",
  "avalancheProblem.no_distinct_avalanche_problem": "Cap problema d'allaus evident",
  "avalancheProblem.new_snow.speech": "un problema de neu recent",
  "avalancheProblem.wind_slab.speech": "un problema de plaques de vent",
  "avalancheProblem.persistent_weak_layers.speech": "un problema de capa feble persistent",
  "avalancheProblem.wet_snow.speech": "un problema de neu humida",
  "avalancheProblem.gliding_snow.speech": "un problema de lliscaments basals",
  "avalancheProblem.favourable_situation.speech": "una situació favorable",
  "avalancheProblem.cornices.speech": "un problema de cornises",
  "avalancheProblem.no_distinct_avalanche_problem.speech": "cap problema d'allaus evident",
  "dangerPattern.label": "Patrons de perill",
  "dangerPattern.dp1": "pp.1: capa feble persistent",
  "dangerPattern.dp2": "pp.2: lliscaments",
  "dangerPattern.dp3": "pp.3: pluja",
  "dangerPattern.dp4": "pp.4: fred desprès de càlid /càlid desprès de fred",
  "dangerPattern.dp5": "pp.5: nevada després d'un període llarg fred",
  "dangerPattern.dp6": "pp.6: neu freda i incohesiva i vent",
  "dangerPattern.dp7": "pp.7: zones de poca neu en entorns amb molta neu",
  "dangerPattern.dp8": "pp.8: gebre de superfície cobert de neu",
  "dangerPattern.dp9": "pp.9: neu granulada coberta de neu",
  "dangerPattern.dp10": "pp.10: escenari de primavera",
  "aspect.N": "Nord",
  "aspect.NE": "Nord-Est",
  "aspect.E": "Est",
  "aspect.SE": "Sud-Est",
  "aspect.S": "Sud",
  "aspect.SW": "Sud-Oest",
  "aspect.W": "Oest",
  "aspect.NW": "Nord-Oest",
  "tendency.label": "Tendència",
  "tendency.decreasing": "Tendència: perill d'allaus en disminució",
  "tendency.steady": "Tendència: Perill d'allaus constant",
  "tendency.increasing": "Tendència: perill d'allaus en augment",
  "validTimePeriod.all_day": "dia sencer",
  "validTimePeriod.all_day.long": "dia sencer",
  "validTimePeriod.earlier": "AM",
  "validTimePeriod.earlier.long": "a primera hora",
  "validTimePeriod.later": "PM",
  "validTimePeriod.later.long": "al final del dia",
  "elevation.treeline.capitalized": "Límit del bosc",
  "elevation.treeline": "límit del bosc",
  "elevation.all": "Totes les altituds",
  "elevation.below": "Per sota de {0}",
  "elevation.above": "Per sobre de {0}",
  "elevation.band": "Entre {0} i {1}",
  "synopsis.label": "Temps",
  "snowpack.label": "Mantell de neu",
  "travelAdvisory.label": "Travel Advisory",
  "forecast.label": "Predicció d'allaus"
}
